var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82812 0V9.31055L12.4648 3.59375H14.0156V9.41992L19.9121 3.59375H21.5625V21.5625H0V0H6.82812ZM1.4375 1.4375V20.125H20.125V5.4043L14.3193 11.1406H12.5781V5.52637L7.04297 11.1406H5.39062V1.4375H1.4375ZM6.83789 17.6719H5.40039V16.2344H6.83789V17.6719ZM10.4316 17.6719H8.99414V16.2344H10.4316V17.6719ZM14.0254 17.6719H12.5879V16.2344H14.0254V17.6719ZM17.6191 17.6719H16.1816V16.2344H17.6191V17.6719ZM6.83789 13V14.4375H5.40039V13H6.83789ZM10.4316 13V14.4375H8.99414V13H10.4316ZM14.0254 13V14.4375H12.5879V13H14.0254ZM17.6191 14.4375H16.1816V13H17.6191V14.4375Z",
    fill: "#2C6199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/Industry.576682c545ca558ba23239208916d6d6.svg";
export { ForwardRef as ReactComponent };